import "./Payouts.css";

const Payouts = ({ setActive }) => {
 return (
  <div className="settings-mobile-payouts">
   <div className="img-container"></div>
   <p>
    We term a payment to you a "payout" when you receive payment for a
    reservation. Our safe payment system allows you to choose from a variety of
    payout options, which you may set up below.
   </p>
   <div className="shapBtn" onClick={() => setActive("addpayoutmethod")}>
    Add Payout Method
   </div>
  </div>
 );
};

export default Payouts;
